import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import OptimizedTooltipText from '@/corePagesModule/components/OptimizedTooltipText.vue';
import { computed, ref } from 'vue';

/**
 * EzCellコンポーネントのプロパティ
 * @property {boolean} forceRight - 内容を右寄せにするかどうか
 * @property {boolean} forceCenter - 内容を中央寄せにするかどうか
 * @property {boolean} isNumber - 数値セルかどうか
 * @property {boolean} isNegative - 負の値を表示するセルかどうか
 * @property {boolean} isHighlighted - ハイライト表示するかどうか
 * @property {number} colspan - セルが占める列数
 */
interface TableCellProps {
  forceRight?: boolean;
  forceCenter?: boolean;
  isNumber?: boolean;
  isNegative?: boolean;
  isHighlighted?: boolean;
  hasRightBorder?: boolean;
  hasBottomBorder?: boolean;
  colspan?: number;
  contentPadding?: number;
  noUseTooltip?: boolean;
  lineHeight?: number;
  sticky?: boolean | 'left' | 'right';
  stickyZIndex?: number;
}

/** 受け取った Props を定義 */

export default /*@__PURE__*/_defineComponent({
  __name: 'EzCell',
  props: {
    forceRight: { type: Boolean, default: false },
    forceCenter: { type: Boolean, default: false },
    isNumber: { type: Boolean, default: false },
    isNegative: { type: Boolean, default: false },
    isHighlighted: { type: Boolean, default: false },
    hasRightBorder: { type: Boolean, default: false },
    hasBottomBorder: { type: Boolean, default: true },
    colspan: { default: 1 },
    contentPadding: { default: 16 },
    noUseTooltip: { type: Boolean },
    lineHeight: { default: 12 },
    sticky: { type: [Boolean, String], default: false },
    stickyZIndex: { default: 1 }
  },
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "366a2efd": (_ctx.stickyZIndex),
  "cefce49e": (`${_ctx.lineHeight}px`),
  "3d3baabc": (`0 ${props.contentPadding}px`)
}))

/**
 * @file TableCell コンポーネント
 * 行や列ごとの配置などの見た目やスタイルに関する部分を担い、
 * 最適化されたツールチップ表示を使用します。
 */

const props = __props;

const tooltipRef = ref<InstanceType<typeof OptimizedTooltipText> | null>(null);

/**
 * セルのCSSクラスを計算
 */
const cellClasses = computed(() => {
  const classes = {};

  if (props.forceRight || props.isNumber) {
    classes['table__cell--right'] = true;
  }

  if (props.forceCenter) {
    classes['table__cell--center'] = true;
  }

  if (props.isNumber) {
    classes['table__cell--number'] = true;
  }

  if (props.isNegative) {
    classes['table__cell--negative'] = true;
  }

  if (props.isHighlighted) {
    classes['table__cell--highlighted'] = true;
  }

  return classes;
});

/**
 * 外側のdivのクラス
 */
const outerClasses = computed(() => {
  const classes = { ...cellClasses.value };

  if (props.hasRightBorder) {
    classes['table__cell--border--right'] = true;
  }
  if (props.hasBottomBorder) {
    classes['table__cell--border--bottom'] = true;
  }
  if (props.sticky === true || props.sticky === 'left') {
    classes['table__cell--sticky'] = true;
    classes['table__cell--sticky--left'] = true;
  } else if (props.sticky === 'right') {
    classes['table__cell--sticky'] = true;
    classes['table__cell--sticky--right'] = true;
  }

  return classes;
});

/**
 * Tooltipに値変更を通知する
 */
const notifyTooltipContentChange = () => tooltipRef.value?.notifyContentChange();

__expose({
  notifyTooltipContentChange,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table__cell", outerClasses.value])
  }, [
    (props.noUseTooltip)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["table__cell__content", cellClasses.value])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : (_openBlock(), _createBlock(OptimizedTooltipText, {
          key: 1,
          ref_key: "tooltipRef",
          ref: tooltipRef,
          class: _normalizeClass(["table__cell__content", cellClasses.value])
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ], undefined, true),
          _: 3
        }, 8, ["class"]))
  ], 2))
}
}

})